import { usePremadeFeedback } from '@quizzach/api-hooks';
import { useQuizOwnershipContext } from '@quizzach/contexts';
import { BqNums, Colors, Hand, KChip, Text, TextSize } from '@quizzach/styles';
import {
	PremadeFeedbackContainer,
	NavButtonWrapper,
} from '@quizzach/play-styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

export const PremadeFeedback = ({
	onButtonClick,
	buttonText,
}: {
	onButtonClick: () => void;
	buttonText: string;
}) => {
	const { t } = useTranslation();
	const { getPremadeQuizUuid } = useQuizOwnershipContext();
	const { sendPremadeFeedback } = usePremadeFeedback();
	const { uuid } = useParams<{ uuid: string }>();
	const [isButtonHovered, setIsButtonHovered] = useState(false);

	const [difficulty, setDifficulty] = useState<number | null>(null);
	const [quality, setQuality] = useState<number | null>(null);

	const handleDifficulty = (level: 1 | 2 | 3) => {
		setDifficulty(difficulty === level ? null : level);
	};

	const handleQuality = (level: 1 | 2 | 3 | 4 | 5) => {
		setQuality(quality === level ? null : level);
	};
	const handleButtonClick = () => {
		if (quality !== null || difficulty !== null) {
			sendPremadeFeedback({
				premade_uuid: getPremadeQuizUuid(uuid as string) as string,
				quality: quality,
				level: difficulty,
			});
		}
		if (navigator.vibrate) navigator.vibrate(30);
		onButtonClick();
	};

	return (
		<>
			<PremadeFeedbackContainer>
				<div>
					<Hand className='feedback-hand' $color='goldOnDark' $big>
						{t('quiz.feedback.qualityQuestion')}
					</Hand>
					<BqNums className='feedback-nums'>
						{[1, 2, 3, 4, 5].map((level) => (
							<button
								key={level}
								type='button'
								className={quality === level ? 'on' : ''}
								onClick={() => handleQuality(level as 1 | 2 | 3 | 4 | 5)}
							>
								<span>{level}</span>
							</button>
						))}
					</BqNums>
				</div>
				<div>
					<Hand className='feedback-hand' $color='goldOnDark' $big>
						{t('quiz.feedback.difficultyQuestion')}
					</Hand>
					<div className='action-container'>
						{[
							t('quiz.difficulty.easy'),
							t('quiz.difficulty.medium'),
							t('quiz.difficulty.hard'),
						].map((label, index) => {
							const level = (index + 1) as 1 | 2 | 3;
							const tone = (['teal', 'gold', 'coral'] as const)[index];
							return (
								<KChip
									key={level}
									type='button'
									$on={difficulty === level}
									$tone={tone}
									onClick={() => handleDifficulty(level)}
								>
									{label}
								</KChip>
							);
						})}
					</div>
				</div>
			</PremadeFeedbackContainer>
			<NavButtonWrapper
				onClick={handleButtonClick}
				onMouseEnter={() => setIsButtonHovered(true)}
				onMouseLeave={() => setIsButtonHovered(false)}
			>
				<Text
					$size={TextSize.l}
					color={isButtonHovered ? Colors.textReverse : Colors.textBrand}
					style={{ margin: 0 }}
				>
					{buttonText}
				</Text>
			</NavButtonWrapper>
		</>
	);
};
